<template>
    <div id="cookie-alert" v-if="value === null" v-show="$route.query.app !== '1'">
      <div class="alert-text">
        {{$t('cookieAlert')}}
        <a
          :href="$i18n.locale === 'en' || $i18n.locale === 'es' ? 'https://tap-dev.ins.to/us/terms/privacy.html' : '/terms/privacy.html'"
          class="link"
          target="_blank"
          >
          {{$t('cookieAlertPrivacy')}}
        </a
        >
      </div>
      <div class="alert-close" @click="acceptCookie()">
        <div class="close"></div>
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
    };
  },
  mounted() {
    this.value = this.$cookie.get("getcookie");
    // console.log(this.value)
  },
  methods: {
    acceptCookie() {
      this.$cookie.set("getcookie", "cookiealert");
      this.value = this.$cookie.get("getcookie");
      // console.log(this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/sass/main.scss";
#cookie-alert {
  width: 100%;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-image: linear-gradient(267deg, #32deff, #2371ff);
  color: $white;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  .alert-text {
    max-width: 540px;
    @media screen and (max-width: 320px) {
      width: 250px;
    }
  }
  a {
    color: $white;
    text-decoration: underline;
    &:hover {
      color: $deepBlue;
    }
  }
}

.alert-close {
  position: relative;
  margin-left: 16px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.close {
  position: absolute;
  width: 20px;
  height: 20px;
  opacity: 0.53;
  &:hover {
    opacity: 1;
  }

  &:before,
  &:after {
    position: absolute;
    top: 5px;
    left: 15px;
    content: " ";
    height: 20px;
    width: 1.5px;
    background-color: $white;
    border-radius: 30px;
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
}
</style>
